module.exports = __webpack_public_path__ + "img/section29.ab0f1c0d.png";